import { getCookie, setCookie, deleteCookie } from './cookies';
import cookieNames from './stashDefaults';

const cookieTypes = Object.keys(cookieNames);
type cookieName = typeof cookieTypes[number];
type AuthData = Record<cookieName, string>;

const createAuthHandler = () => {
	// attempt to load values from cookies into memory on app start
	const data: Partial<AuthData> = {
		accessToken: getCookie(cookieNames.accessToken),
		refreshToken: getCookie(cookieNames.refreshToken),
		uuid: getCookie(cookieNames.uuid),
	};

	const get = () => {
		// read values from cookies to keep in sync with main web repo
		return {
			accessToken: getCookie(cookieNames.accessToken),
			refreshToken: getCookie(cookieNames.refreshToken),
			uuid: getCookie(cookieNames.uuid),
		} as Partial<AuthData>;
	};

	const set = (newData: AuthData) => {
		Object.keys(newData).forEach((key) => {
			setCookie(cookieNames[key as keyof typeof cookieNames], newData[key]);
			data[key] = newData[key];
		});
	};

	const deleteAll = () => {
		Object.keys(data).forEach((key) => {
			delete data[key];
			deleteCookie(cookieNames[key as keyof typeof cookieNames]);
		});
	};

	const logOut = (reason: string) => {
		deleteAll();
		window.localStorage && window.localStorage.clear();
		window.sessionStorage && window.sessionStorage.clear();

		// Do a hard redirect on window to clear memory.
		window.setTimeout(() => {
			window.location.href = `/log-in?reason=${reason || ''}`;
		}, 300);
	};

	return {
		get,
		set,
		deleteAll,
		logOut,
	};
};

export default createAuthHandler();
